import React from "react";

type AttentionIconProps = {
  fillBackground?: string;
  fillMarker?: string;
  height?: number;
  width?: number;
  className?: string;
};

export const AttentionIcon: React.FC<AttentionIconProps> = (props) => {
  const {
    fillMarker = "var(--surface-text-error-light)",
    fillBackground = "none",
    height = 26,
    width = 26,
    className,
  } = props;

  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 26 26"
      fill={fillBackground}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 19.3077C13.3051 19.3077 13.5609 19.2045 13.7673 18.998C13.9738 18.7916 14.077 18.5358 14.077 18.2307C14.077 17.9256 13.9738 17.6698 13.7673 17.4633C13.5609 17.2571 13.3051 17.154 13 17.154C12.6949 17.154 12.4391 17.2571 12.2327 17.4633C12.0262 17.6698 11.923 17.9256 11.923 18.2307C11.923 18.5358 12.0262 18.7916 12.2327 18.998C12.4391 19.2045 12.6949 19.3077 13 19.3077ZM12 14.436H14V6.43601H12V14.436ZM13.0023 25.6667C11.2503 25.6667 9.60355 25.3342 8.06199 24.6693C6.52044 24.0045 5.17955 23.1021 4.03933 21.9623C2.89911 20.8226 1.99633 19.4822 1.33099 17.9413C0.665884 16.4005 0.333328 14.7541 0.333328 13.0023C0.333328 11.2503 0.665773 9.60357 1.33066 8.06201C1.99555 6.52045 2.89788 5.17956 4.03766 4.03934C5.17744 2.89912 6.51777 1.99634 8.05866 1.33101C9.59955 0.665899 11.2459 0.333344 12.9977 0.333344C14.7497 0.333344 16.3964 0.665787 17.938 1.33068C19.4795 1.99557 20.8204 2.8979 21.9607 4.03768C23.1009 5.17745 24.0037 6.51779 24.669 8.05868C25.3341 9.59957 25.6667 11.2459 25.6667 12.9977C25.6667 14.7497 25.3342 16.3965 24.6693 17.938C24.0044 19.4796 23.1021 20.8205 21.9623 21.9607C20.8225 23.1009 19.4822 24.0037 17.9413 24.669C16.4004 25.3341 14.7541 25.6667 13.0023 25.6667ZM13 23.6667C15.9778 23.6667 18.5 22.6333 20.5667 20.5667C22.6333 18.5 23.6667 15.9778 23.6667 13C23.6667 10.0222 22.6333 7.50001 20.5667 5.43334C18.5 3.36668 15.9778 2.33334 13 2.33334C10.0222 2.33334 7.49999 3.36668 5.43333 5.43334C3.36666 7.50001 2.33333 10.0222 2.33333 13C2.33333 15.9778 3.36666 18.5 5.43333 20.5667C7.49999 22.6333 10.0222 23.6667 13 23.6667Z"
        fill={`${fillMarker}`}
      />
    </svg>
  );
};
